module.exports = __webpack_public_path__ + "img/intro3.c4839130.jpg";